import type { RouteRecordRaw } from 'vue-router';

export const forexRoutes: Array<RouteRecordRaw> = [
  {
    path: '/forex',
    name: 'forex',
    redirect: '/forex/source/list',
    component: () => import('pages/info/forex/forexSource/ForexSource.vue'),
    meta: {
      title: 'Forex Services',
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: '/forex/source',
    name: 'forexSource',
    redirect: '/forex/source/list',
    component: () => import('pages/info/forex/forexSource/ForexSource.vue'),
    meta: {
      title: 'Forex API Sources',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'forexSourceList',
        component: () => import('pages/info/forex/forexSource/SourceList.vue'),
        meta: {
          title: 'Forex API Sources List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'forexSourceDetail',
        component: () => import('pages/info/forex/forexSource/SourceDetail.vue'),
        meta: {
          title: 'Forex Source Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'forexSourceNew',
        component: () => import('pages/info/forex/forexSource/SourceNew.vue'),
        meta: {
          title: 'New Forex Source',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/forex/exchange',
    name: 'forexExchange',
    redirect: '/forex/exchange/list',
    component: () => import('pages/info/forex/forexExchange/ForexExchange.vue'),
    meta: {
      title: 'Forex API Exchanges',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'forexExchangeList',
        component: () =>
          import('pages/info/forex/forexExchange/ForexExchangeList.vue'),
        meta: {
          title: 'Forex API Exchanges List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'forexExchangeDetail',
        component: () =>
          import('pages/info/forex/forexExchange/ForexExchangeDetail.vue'),
        meta: {
          title: 'Forex Exchange Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'forexExchangeNew',
        component: () =>
          import('pages/info/forex/forexExchange/ForexExchangeNew.vue'),
        meta: {
          title: 'New Forex Exchange',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/forex/data',
    name: 'forexData',
    redirect: '/forex/data/list',
    component: () => import('pages/info/forex/forexData/ForexData.vue'),
    meta: {
      title: 'Forex API Datas',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'forexDataList',
        component: () => import('pages/info/forex/forexData/ForexDataList.vue'),
        meta: {
          title: 'Forex API Datas List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'forexDataDetail',
        component: () => import('pages/info/forex/forexData/ForexDataDetail.vue'),
        meta: {
          title: 'Forex Data Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'forexDataNew',
        component: () => import('pages/info/forex/forexData/ForexDataNew.vue'),
        meta: {
          title: 'New Forex Data',
          requiresAuth: true,
        },
      },
    ],
  },
];
